import { z } from 'zod';
export var UserRole;
(function (UserRole) {
    UserRole["Guest"] = "guest";
    UserRole["User"] = "user";
    UserRole["Admin"] = "admin";
    UserRole["System"] = "system";
})(UserRole || (UserRole = {}));
export const avatarColors = {
    coulter: 'inverse',
    sunset: 'default',
    alluvium: 'default',
    arroyoSeco: 'inverse',
    beesBliss: 'default',
    fire: 'default',
    ballona: 'inverse',
    sprout: 'default',
    compost: 'inverse',
    sky: 'default',
    sand: 'default',
    surfliner: 'default',
    manzanita: 'inverse',
    sage: 'default',
    twilight: 'inverse'
};
// Schema for avatar color validation
const AvatarColorSchema = z.enum(Object.keys(avatarColors));
export const BaseUserSchema = z.object({
    email: z.string().email(),
    firstName: z.string(),
    lastName: z.string(),
    avatarColor: AvatarColorSchema,
    organization: z.string().optional()
});
// Base user with ID
export const BaseUserWithIdSchema = BaseUserSchema.extend({
    _id: z.string()
});
// JWT user (no organization, adds role)
export const JWTUserSchema = BaseUserWithIdSchema.omit({
    organization: true
}).extend({
    role: z.nativeEnum(UserRole)
});
// Full user schema
export const UserSchema = BaseUserWithIdSchema.extend({
    password: z.string(),
    created: z.date(),
    confirmed: z.boolean(),
    resetPasswordToken: z.string(),
    resetPasswordExpires: z.date(),
    toolAnalytics: z.boolean(),
    privacyAccepted: z.date().optional(),
    marketingAccepted: z.date().optional(),
    hasSeenOnboardingModal: z.boolean().optional(),
    role: z.nativeEnum(UserRole)
});
// Guest schema
export const GuestSchema = z.object({
    _id: z.string(),
    created: z.date(),
    role: z.literal(UserRole.Guest),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    privacyAccepted: z.literal(true)
});
export const UserValidationSchema = BaseUserSchema.extend({
    password: z.string()
});
//# sourceMappingURL=user.js.map